<div class="portal-shell">
  <investigator-shell-bar></investigator-shell-bar>

  <div class="portal-body">
    <investigator-side-nav></investigator-side-nav>
    <main class="portal-content">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
